import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { videoSchemas } from "./videoSchemas";

function normalizePath(path) {
  if (!path) return "/";
  return path.replace(/\/+$/, "") || "/";
}

export default function VideoSchema() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalized = normalizePath(pathname);
    const schema = videoSchemas[normalized];
    if (!schema) return;

    const SCRIPT_ID = "video-schema-jsonld";

    const existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = SCRIPT_ID;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const old = document.getElementById(SCRIPT_ID);
      if (old) old.remove();
    };
  }, [pathname]);

  return null;
}
